import { render, staticRenderFns } from "./TeamMemberList.vue?vue&type=template&id=c25330b6&"
import script from "./TeamMemberList.vue?vue&type=script&lang=js&"
export * from "./TeamMemberList.vue?vue&type=script&lang=js&"
import style0 from "./TeamMemberList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports